module.exports = __webpack_public_path__ + "static/media/wisepos.6191ec6e.png";